{
    "account_delete.confirm_heading": "Êtes-vous sûr de vouloir supprimer les données associées à votre profil ?",
    "article.login_button": "Se connecter",
    "audience_input.composer_placeholder": "Partagez votre avis...",
    "blocklist.description": "Gérer les termes qui doivent être signalés automatiquement.",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "dessélectionné",
    "comment_slider.change_vote_button": "Modifier ma réponse",
    "comment_slider.no_with_reservations": "Plutôt non",
    "comment_slider.share_thoughts": "Partagez votre avis",
    "comment_slider.slide_to_respond": "Déplacez le curseur pour répondre : ",
    "comment_slider.update_response": "Modifier ma réponse",
    "comment_slider.yes_with_reservations": "Plutôt oui",
    "community_guidelines.category_engage_respectfully": "Soyez respectueux",
    "community_guidelines.category_support_claims": "Expliquez vos propos",
    "community_guidelines.rule_avoid_derogatory_labels": "Évitez les propos dénigrants",
    "community_guidelines.rule_no_offtopic": "Pas de commentaires hors sujet",
    "conversation_helper.about": "A propos de l'assistant de conversation",
    "conversation_helper.generated_by_ai": "Conseils générés par l'IA",
    "conversationhelper.ai.hint": "Afin de maintenir une atmosphère accueillante et respectueuse, nous utilisons une IA pour soutenir la modération. Dans cette conversation, une IA donne des indications pour favoriser une discussion constructive et résume les sujets abordés.",
    "editorial_question.share_thoughts": "Partagez votre avis",
    "login.cookie_notice": "🍪 Cet espace de conversation utilise uniquement des cookies essentiels. Nous n'utilisons pas de cookies à des fins publicitaires. [En savoir plus]({privacyNoticeLink}).",
    "moderation.email_notification": "Vous recevrez une notification par e-mail lorsque votre publication sera approuvée ou rejetée par les modérateurs.",
    "moderation.email_notification_notice": "Vous recevrez une notification par e-mail lorsque votre publication sera approuvée ou rejetée par les modérateurs.",
    "moderation.provide_details_help": "Fournissez tous les détails pour nous aider à déterminer si votre commentaire respecte les règles de la communauté.",
    "moderation.thank_you": "Merci !",
    "moderation.what_happens_next": "📫 Quelle est la prochaine étape ?",
    "perspectives.enter_label_placeholder": "Votre perspective",
    "perspectives.how_relate_question": "Comment vous identifiez-vous par rapport au sujet ?",
    "perspectives.share_thoughts_button": "Partagez votre avis",
    "profile.beta_feedback_note": "En participant à cette version de test (bêta), vous pourriez être invité à donner votre avis sur votre expérience",
    "profile.collaboration_note": "Cet espace de conversation est hébergé par New_ Public en collaboration avec la {psmName}.",
    "profile.error_name_invalid": "Les pseudonymes doivent contenir uniquement des lettres minuscules et des chiffres.",
    "profile.error_name_taken": "Ce pseudonyme existe déjà.",
    "question.input_placeholder": "Partagez votre avis...",
    "rating.no_with_reservations": "Plutôt non",
    "rating.yes_with_reservations": "Plutôt oui",
    "satisfaction_survey_popover.question": "Quel est votre niveau de satisfaction de l'outil de conversation?",
    "single_response_help.update_response_label": "Mettez à jour votre réponse si votre avis a changé.",
    "tag.beta": "Bêta",
    "user_info.log_in_button": "Se connecter",
    "video_voting.time": "Temps :"
}
